export default {"src":"/_next/static/media/uti.9ea10368.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};